export default __webpack_public_path__ + "static/media/set_expectations.5eefe3b8.png";